import cn from 'classnames';
import React from 'react';

import {getLocalizedStrings} from '../../../services/localization/localizationService';
import AppButton from '../../Button/AppButton/AppButton';
import ConnectionTrackButton from '../../Button/ConnectionTrackButton/ConnectionTrackButton';
import {ErrorIcon} from '../../Icons';
import {MaxWidthContainer} from '../../Layout';

const Article = (props) => {
    const {
        titleText,
        titleKey,
        titleClassName,
        descriptionContent,
        descriptionKey,
        descriptionText,
        subDescription,
        children,
        error,
        icon,
        className,
        buttonPrimary,
        buttonSecondary,
        size,
    } = props;
    const localizedStrings = getLocalizedStrings();
    const Icon = getIcon({error});
    const title = titleText || localizedStrings[titleKey];
    const description = descriptionText || localizedStrings[descriptionKey];

    return (
        <MaxWidthContainer className={className} size={size}>
            {icon && icon}
            {Icon && <Icon className='mb-4 h-6 w-6 lg:mb-6 lg:h-8 lg:w-8' />}
            <h1
                className={cn({'mb-0': !description && !descriptionContent}, titleClassName)}
                dangerouslySetInnerHTML={{
                    __html: title,
                }}
            />
            {descriptionContent && descriptionContent}
            {description && (
                <p>
                    <span
                        className='whitespace-pre-line'
                        dangerouslySetInnerHTML={{
                            __html: description,
                        }}
                    />
                    {subDescription && subDescription}
                </p>
            )}
            {buttonPrimary && !buttonSecondary && <Button primary {...buttonPrimary} />}
            {!buttonPrimary && buttonSecondary && <Button secondary {...buttonSecondary} />}
            {buttonPrimary && buttonSecondary && (
                <div className='mt-10 flex w-full flex-col gap-4 md:w-auto'>
                    <Button primary className='m-0' {...buttonPrimary} />
                    <Button secondary className='m-0' {...buttonSecondary} />
                </div>
            )}
            {children}
        </MaxWidthContainer>
    );
};

export default Article;

const Button = (props) => {
    const {textKey, text, ariaLabelKey, isConnectionTrack, ...rest} = props;
    const localizedStrings = getLocalizedStrings();
    const buttonText = textKey ? localizedStrings[textKey] : text;
    const CustomButton = isConnectionTrack ? ConnectionTrackButton : AppButton;

    return (
        <CustomButton
            button={isConnectionTrack ? AppButton : undefined}
            light
            ariaLabel={ariaLabelKey ? localizedStrings[ariaLabelKey] : undefined}
            {...rest}
        >
            {buttonText}
        </CustomButton>
    );
};

const getIcon = ({error}) => {
    if (error) {
        return ErrorIcon;
    }

    return null;
};
